import PropTypes from "prop-types";
import Header2 from "../components/header/Header2";
import Breadcrumb from "../components/breadcrumb";
import Footer from "../components/footer";
import { Link } from "react-router-dom";
import Gotop from "../components/gotop";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../assets/images/logo.png";
import avt from "../assets/images/user/avatar/image-01.jpg";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Mobile from "../components/mobile";
import BASE_URL from "../apiconfig";

Checkout.propTypes = {};

function Checkout(props) {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    texp: "",
    texpm: "",
    qualfi: "",
    ctc: "",
    ectc: "",
    address: "",
    country: "",
    cwl: "",
    dob: "",
    nl: "",
    passport: "",
    jtime: "",
    travel: "",
    designation: "",
    key_skill: "",
    functions: "",
    roles: "",
    current_industry: "",
    category_id: "",
    profile_id: "",
    past_industry: "",
  });
  const [domains, setDomains] = useState([]);
  const [categories, setCategories] = useState([]);
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    const email = localStorage.getItem("email");
    if (email) {
      axios
        .post(`${BASE_URL}/user/dashboard/getJobSeekerData`, { email })
        .then((response) => {
          console.log("Backend response data:", response.data);
          if (response.data && !response.data.error) {
            setFormData({
              ...response.data,
              email: email,
            });
            if (response.data.current_industry) {
              fetchCategories(
                response.data.current_industry,
                response.data.category_id || ""
              );

              if (response.data.category_id && response.data.profile_id) {
                setTimeout(() => {
                  fetchProfiles(
                    response.data.category_id,
                    response.data.profile_id
                  );
                }, 200);
              }
            }
          } else {
            console.log(
              "No job seeker data found or error:",
              response.data.error
            );
          }
        })
        .catch((error) =>
          console.error("Error fetching job seeker data: ", error)
        );

      // 2. Fetch All Domains
      axios
        .get(`${BASE_URL}/user/dashboard/getAllDomains`)
        .then((response) => {
          if (response.data) {
            setDomains(response.data);
          }
        })
        .catch((error) => console.error("Error fetching domains: ", error));
    } else {
      console.error("Email not found in localStorage.");
    }
  }, []);

  const fetchCategories = (domainId, selectedCategoryId = "") => {
    axios
      .post(`${BASE_URL}/user/dashboard/getCategoriesByDomainname`, {
        domain_id: domainId,
      })
      .then((response) => {
        if (response.data) {
          setCategories(response.data);
          setProfiles([]); 
          setFormData((prev) => ({
            ...prev,
            category_id: selectedCategoryId || "",
            profile_id: "",
          }));
        }
      })
      .catch((error) => console.error("Error fetching categories: ", error));
  };

  const fetchProfiles = (categoryId, selectedProfileId = "") => {
    axios
      .post(`${BASE_URL}/user/dashboard/getProfilesByCategoryname`, {
        category_id: categoryId,
      })
      .then((response) => {
        if (Array.isArray(response.data)) {
          setProfiles(response.data);
          setFormData((prev) => ({
            ...prev,
            profile_id: selectedProfileId || "",
          }));
        } else {
          console.error("Profiles API did not return an array:", response.data);
          setProfiles([]);
        }
      })
      .catch((error) => console.error("Error fetching profiles: ", error));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "current_industry") {
      if (value) {
        fetchCategories(value);
      } else {
        setCategories([]);
        setProfiles([]);
        setFormData((prev) => ({
          ...prev,
          category_id: "",
          profile_id: "",
        }));
      }
    } else if (name === "category_id") {
      if (value) {
        fetchProfiles(value);
      } else {
        setProfiles([]);
        setFormData((prev) => ({
          ...prev,
          profile_id: "",
        }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { current_industry, category_id, profile_id } = formData;

    if (!current_industry || !category_id || !profile_id) {
      alert("Please fill the carear profile section");
      return;
    }
    if (!formData.email) {
      alert("Email is required.");
      return;
    }

    const updatedData = {
      email: formData.email,
      ...(formData.mobile && { mobile: formData.mobile }),
      ...(formData.name && { name: formData.name }),
      ...(formData.qualfi && { qualfi: formData.qualfi }),
      ...(formData.texp && { texp: formData.texp }),
      ...(formData.texpm && { texpm: formData.texpm }),
      ...(formData.ctc && { ctc: formData.ctc }),
      ...(formData.ectc && { ectc: formData.ectc }),
      ...(formData.address && { address: formData.address }),
      ...(formData.country && { country: formData.country }),
      ...(formData.cwl && { cwl: formData.cwl }),
      ...(formData.dob && { dob: formData.dob }),
      ...(formData.nl && { nl: formData.nl }),
      ...(formData.passport && { passport: formData.passport }),
      ...(formData.jtime && { jtime: formData.jtime }),
      ...(formData.travel && { travel: formData.travel }),
      ...(formData.designation && { designation: formData.designation }),
      ...(formData.key_skill && { key_skill: formData.key_skill }),
      ...(formData.functions && { functions: formData.functions }),
      ...(formData.roles && { roles: formData.roles }),
      ...(formData.current_industry && {
        current_industry: formData.current_industry,
      }),
      ...(formData.past_industry && { past_industry: formData.past_industry }),
      ...(formData.category_id && { category_id: formData.category_id }),
      ...(formData.profile_id && { profile_id: formData.profile_id }),
    };

    axios
      .post(`${BASE_URL}/user/dashboard/updateJobSeeker`, updatedData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          alert("Profile updated successfully.");
          window.location.reload();
        } else {
          alert("Failed to update profile. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error updating profile: ", error);
        alert("Error occurred while updating profile.");
      });
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    navigate("/");
    window.location.reload();
  };

  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  return (
    <>
      <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

          <Tabs className="tf-tab">
            <TabList className="menu-tab">
              <Tab className="user-tag">Menu</Tab>
              {/* <Tab className="user-tag">Categories</Tab> */}
            </TabList>

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link to="/job-grid">Browse jobs </Link>
                      </li>
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link to="/employers_v3">Companies </Link>
                      </li>
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link to="/pricing">Pricing </Link>
                      </li>
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link to="/faqs">Services </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>
            </div>
          </Tabs>

          <div className="header-customize-item button">
            {/* <Link to="/">Upload Resume</Link> */}
            <Mobile />
          </div>

          <div className="mobile-footer">
            <div className="icon-infor d-flex aln-center">
              <div className="icon">
                <span className="icon-call-calling">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
              </div>
              <div className="content">
                <p>Need help? 24/7</p>
                <h6>
                  <Link to="tel:9811226910">9811226910</Link>
                </h6>
              </div>
            </div>
            <div className="wd-social d-flex aln-center">
              <ul className="list-social d-flex aln-center">
                <li>
                  <Link to="#">
                    <i className="icon-facebook"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="icon-linkedin2"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="icon-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="icon-pinterest"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="icon-instagram1"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="icon-youtube"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Header2 clname="actPage4" handleMobile={handleMobile} />
      <section className="checkout-section">
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-4 sticky-sidebar mt-4">
              <div className="shop-content margin content-stc">
                <div className="wd-order">
                  <div className="info d-flex justify-content-center align-items-center">
                    <img
                      src={
                        formData.photo
                          ? `${BASE_URL}/uploads/${formData.photo}`
                          : avt
                      }
                      alt="jobtex"
                      style={{
                        width: "100px",
                        height: "100px",
                        border: "2px solid #ccc",
                        borderRadius: "50%",
                        display: "block",
                        marginBottom: "10px",
                      }}
                    />
                  </div>
                  <div className=" d-flex justify-content-center align-items-center">
                    <h5>{formData.name}</h5>
                  </div>
                  <div className="bg-checkout">
                    <div className="product-list">
                      <div className="product-item">
                        <div className="info">
                          <h6>
                            <Link to="/checkout">My Profile</Link>
                          </h6>
                        </div>
                      </div>
                      <div className="product-item">
                        <div className="info">
                          <h6>
                            <Link to="/checkout2">My details and resume</Link>
                          </h6>
                        </div>
                      </div>
                      <div className="header-customize-item button">
                        <button
                          style={{
                            padding: "10px 20px",
                            backgroundColor: "#14a077",
                            color: "white",
                            textDecoration: "none",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                          }}
                          onClick={handleLogout}
                        >
                          Logout
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7 p-5">
              <div className="form-candidate form-checkout form-stc">
                <div className="group-title">
                  <h6>Personal Details</h6>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Full Name:<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Mobile Number:<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Email Address:<span style={{ color: "red" }}>*</span>
                        </label>

                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Total Experience in Years:
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="number"
                          value={formData.texp}
                          name="texp"
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Total Experience in Months:
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="number"
                          value={formData.texpm}
                          name="texpm"
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Highest Qualification:
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          name="qualfi"
                          value={formData.qualfi}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="10th">10th</option>
                          <option value="12th">12th</option>
                          <option value="Graduation/Diploma">
                            Graduation/Diploma
                          </option>
                          <option value="Masters/Post-Graduation">
                            Masters/Post-Graduation
                          </option>
                          <option value="Doctorate/PhD">Doctorate/PhD</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Current Salary per year (in rupees):
                          <span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <input
                          value={formData.ctc}
                          onChange={handleInputChange}
                          name="ctc"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Expected Salary per year (in rupees):
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.ectc}
                          onChange={handleInputChange}
                          name="ectc"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="group-input-st1">
                        <label>
                          Full Address:<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.address}
                          onChange={handleInputChange}
                          name="address"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row border-bottom">
                    <div className="mb-4 border-bottom">
                      <p className="text-secondary pb-2 fs-5">Career Profile</p>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label htmlFor="current_industry">
                        Current Industry:<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="current_industry"
                        id="current_industry"
                        value={formData.current_industry}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">
                          Select Industry:
                          <span style={{ color: "red" }}>*</span>
                        </option>
                        {domains.map((domain) => (
                          <option key={domain.id} value={domain.id}>
                            {domain.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Category Select (dependent on Industry) */}
                    <div className="col-md-6 mb-2">
                      <label htmlFor="category_id">
                        Category:<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="category_id"
                        id="category_id"
                        value={formData.category_id}
                        onChange={handleInputChange}
                        disabled={categories.length === 0} // Disable if no industry is selected
                      >
                        <option value="">Select Category</option>
                        {categories.map((category) => (
                          <option key={category.id} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Job Profile Select (dependent on Category) */}
                    <div className="col-md-6 mb-2">
                      <label htmlFor="profile_id">
                        Job Profile:<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="profile_id"
                        id="profile_id"
                        value={formData.profile_id}
                        onChange={handleInputChange}
                        disabled={profiles.length === 0} // Disable if no category is selected
                      >
                        <option value="">Select Job Profile</option>
                        {profiles.map((profile) => (
                          <option key={profile.id} value={profile.id}>
                            {profile.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6 mb-2">
                      <label>
                        Roles:<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={formData.roles}
                        onChange={handleInputChange}
                        name="roles"
                        type="text"
                        required
                      />
                    </div>
                    <div className="col-md-12">
                      <div className="group-input-st1">
                        <label>
                          Key Skills:<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.key_skill}
                          onChange={handleInputChange}
                          name="key_skill"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Designation:<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.designation}
                          onChange={handleInputChange}
                          name="designation"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Functions:<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.functions}
                          onChange={handleInputChange}
                          name="functions"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Past Industry:<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.past_industry}
                          onChange={handleInputChange}
                          name="past_industry"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Country:<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.country}
                          onChange={handleInputChange}
                          name="country"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Current Work Location:
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.cwl}
                          onChange={handleInputChange}
                          name="cwl"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Date of Birth:<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.dob}
                          onChange={handleInputChange}
                          name="dob"
                          type="date"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Nationality:<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          value={formData.nl}
                          onChange={handleInputChange}
                          name="nl"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>Passport Number:</label>
                        <input
                          value={formData.passport}
                          onChange={handleInputChange}
                          name="passport"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Joining Time:<span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          name="jtime"
                          value={formData.jtime}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="immdiately">immdiately</option>
                          <option value="with in 15 days">
                            with in 15 days
                          </option>
                          <option value="with in 30 days">
                            with in 30 days
                          </option>
                          <option value="with in 45 days">
                            with in 45 days
                          </option>
                          <option value="with in 60 days">
                            with in 60 days
                          </option>
                          <option value="with in 90 days">
                            with in 90 days
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="group-input-st1">
                        <label>
                          Are you willing to travel:
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          name="travel"
                          value={formData.travel}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="header-customize-item button">
                    <button
                      type="submit"
                      style={{
                        padding: "10px 20px",
                        backgroundColor: "#3498db",
                        color: "white",
                        textDecoration: "none",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Update Profile
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Gotop />
    </>
  );
}

export default Checkout;
